import { get } from 'lodash';
import {
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_DESCRIPTION,
  QUESTION_RATING,
  QUESTION_SLIDER,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERICAL_OPEN_ENDED,
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_NPS,
  QUESTION_MATRIX_VAN_WESTENDORP,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_OPEN_ENDED_NUMERIC,
  QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM,
  QUESTION_MATRIX_MAXDIFF,
} from '../../constants';

const getQuestionPromptText = (question, getText) => {
  let questionPromptText = '';
  if (question.min !== undefined && question.max !== undefined) {
    if (question.min === 1 && question.max !== question.answers.length) {
      questionPromptText = `${getText('selectNoMore')} ${
        question.max
      } ${getText('answers')}`;
    } else if (question.max === question.answers.length && question.min !== 1) {
      questionPromptText = `${getText('least')} ${question.min} ${getText(
        'answers',
      )}`;
    } else if (question.min === 1 && question.max === question.answers.length) {
      questionPromptText = getText('choose_multiple');
    } else {
      questionPromptText = `${getText('least')} ${question.min}
        ${getText('noMore')} ${question.max} ${getText('answers')}`;
    }
  } else {
    questionPromptText = getText('choose_multiple');
  }

  return questionPromptText;
};

const getQuestionPromptFreeTextNumerical = (question, getText) => {
  let questionPromptText = '';
  if (question.min !== undefined || question.max !== undefined) {
    if (question.max === undefined) {
      questionPromptText = `${getText('inputAtLeast')} ${question.min}`;
    } else if (question.min === undefined) {
      questionPromptText = `${getText('inputNoMore')} ${question.max}`;
    } else {
      questionPromptText = `${getText('inputAtLeast')} ${
        question.min
      } ${getText('noMoreThan')} ${question.max}`;
    }
  } else {
    questionPromptText = getText('freeText');
  }

  return questionPromptText;
};

const getQuestionPromptMaxDiff = (question, getText) => {
  const textLabelBest = get(question, 'matrix.columns[0].beforeLabel', '');
  const textLabelWorst = get(question, 'matrix.columns[1].beforeLabel', '');

  return getText('matrixMaxDiff')
    .replace('XXX', textLabelBest)
    .replace('YYY', textLabelWorst);
};

export const getQuestionPrompt = (question, getText) => {
  let text = '';
  switch (question.style) {
    case QUESTION_SINGLE:
    case QUESTION_NPS:
      text = getText('choose_one');
      break;
    case QUESTION_DESCRIPTION:
      text = getText('description');
      break;
    case QUESTION_MULTIPLE:
      text = getQuestionPromptText(question, getText);
      break;
    case QUESTION_RATING:
      text = getText('rate');
      break;
    case QUESTION_SLIDER:
      text = getText('slider');
      break;
    case QUESTION_OPEN_ENDED:
      text = getText('freeText');
      break;
    case QUESTION_NUMERICAL_OPEN_ENDED:
      text = getQuestionPromptFreeTextNumerical(question, getText);
      break;
    case QUESTION_RANKING:
      text = getText('rank');
      break;
    case QUESTION_MATRIX_SINGLE:
      text = getText('matrix');
      break;
    case QUESTION_MATRIX_MULTIPLE:
      text = getText('matrixMultiple');
      break;
    case QUESTION_MATRIX_VAN_WESTENDORP:
      text = getText('matrixVanWestendorp');
      break;
    case QUESTION_MATRIX_BIPOLAR:
      text = getText('bipolar.matrix');
      break;
    case QUESTION_MATRIX_OPEN_ENDED:
    case QUESTION_MATRIX_OPEN_ENDED_NUMERIC:
    case QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM:
      text = getText('matrixNumericOpenEnded');
      break;
    case QUESTION_MATRIX_MAXDIFF:
      text = getQuestionPromptMaxDiff(question, getText);
      break;
    default:
      text = getText('choose_one');
  }

  if (question.f_name === 'dg_year_of_birth') {
    text = getText('date');
  }

  return text;
};

export const isEmptyPrompt = (prompt) => prompt === '<div></div>';
